import z from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

export const USER_CHANGE_PASSWORD_TYPE = 'user/change-password';

export const userChangePassword = defineCommand(
    USER_CHANGE_PASSWORD_TYPE,
    z.object({
        email: z.email(),
        sessionId: z.string().min(1).optional(),
        newPassword: z.string().min(1),
        currentPassword: z.string().min(1).optional(),
    }),
);

export const USER_REQUEST_PASSWORD_RESET_TYPE = 'user/request-password-reset';
export const USER_CONFIRM_PASSWORD_RESET_TYPE = 'user/confirm-password-reset';

export const userRequestPasswordReset = defineCommand(
    USER_REQUEST_PASSWORD_RESET_TYPE,
    z.object({ email: z.email().min(1) }),
    // Enumeration-safe: identical whether or not an account exists.
    z.object({ accepted: z.literal(true).meta(metadata.nonSensitive) }),
);

export const userConfirmPasswordReset = defineCommand(
    USER_CONFIRM_PASSWORD_RESET_TYPE,
    z.object({
        token: z.string().min(1),
        password: z.string().min(1),
    }),
    z.object({ success: z.literal(true).meta(metadata.nonSensitive) }),
);
